import React, { useContext, useEffect, useState } from 'react';
import { CotizadorHNDataContext } from '../../context/CotizadorHNDataContext';
import { coberturaEquipoEspecial, coberturasOpcionales, coberturasRequeridas, planes, isOldVh } from '../../data/cotizadorHnData';
import { frecuenciaPagos } from '../../data/mochaData';
import http from '../../services/http';
import { customStyles, endPoints, monedas } from '../../utils/constanst';
import DivRow from '../../components/controls/DivRow';
import Input from '../../components/controls/Input';
import InputSelect from '../../components/controls/InputSelect';
import SwitchButton from '../../components/controls/SwitchButton';
import Resumen from './Resumen';
import tarificar, { calculatePrima, getResumen, anexarCobertura, computeRateResult } from '../../services/tarificar';
import Modal from 'react-modal';
import { FaPlus, FaPen, FaInfoCircle } from "react-icons/fa";
import { ImgAlert, ImgAlertCallCenter, ImgAlertOk } from '../../svg';
import ReactTooltip from 'react-tooltip';
import { round } from '../../utils/helpers';



const Step2 = () => {

    const coberturaEspecialDefault = { customName: null, sa: null, sumInsureds: [], showDialog: false };
    const [coberturaEspecial, setCoberturaEspecial] = useState({ ...coberturaEspecialDefault });

    const [optCoverages, setOptCoverages] = useState([]);
    const { poliza, tarificacion, catalogos, setPoliza, setTarificacion, setCatalogos, polizaChangeHandler, tarificacionChangeHandler, init } = useContext(CotizadorHNDataContext);

    const [dialogs, setDialogs] = useState({ showFailDialog: false });

    useEffect(() => {
        setOptCoverages(generateOptionalCoverages());
    }, []);



    const getName = (cobId) => {
        let r = catalogos.coberturas.coverages.find(x => x.idCob == cobId);
        return r != null ? r.nombre : '';
    }

    const isChecked = (rates, cobId) => {
        return rates.some(x => x.idCob == cobId);
    }



    const optionsHnl = { style: 'currency', currency: 'HNL' };
    const numberFormatHnl = new Intl.NumberFormat('es-HN', optionsHnl);

    const format = (n) => {
        if (n == null)
            n = 0;
        n = Number.parseFloat(n).toFixed(2);
        return numberFormatHnl.format(n);

    }

    const formartPercent = (n) => {
        n = Number.parseFloat(n).toFixed(2) + '%';
        return n;
    }

    const getCoverage = (rates, id) => rates.find(x => x.idCob == id);

    const onCoverageChange = (coverage) => {

        let t = anexarCobertura(tarificacion, coverage);

        let opts = optCoverages.filter(x => x.cobId != coverage.cobId);
        setOptCoverages([...opts, coverage]);
        setTarificacion(t);
        computeRates(t);
    }

    const computeRates = (t) => {

        const tarificarPlan = tarificar(poliza.planId);
        tarificarPlan(t).then(resp => {
            setPoliza(computeRateResult(poliza, resp.rates));
            let opts = generateOptionalCoverages(resp.rates);
            setOptCoverages(prev => {
                mergeSelectedSA(prev, opts);
                return opts;
            });

        }).catch(error => {
            openFailTeminos();
            console.log(error);
        });
    }

    const mergeSelectedSA = (prev, current) => {
        const prop = 'selectedSA'
        prev.forEach(element => {
            if (element[prop] != undefined) {
                let c = current.find(x => x.cobId == element.cobId);
                if (c != null) {
                    c[prop] = element[prop];
                }
            }
        });
    }

    const getDescuento = (cov) => {
        let descuneto = 0;
        let prima = cov != null ? parseFloat(cov.prima) : 0;
        if (cov != null && cov.pRecargo > 0)
            prima = prima + (prima * cov.pRecargo) / 100;
        if (cov != null && cov.descuentos != null && cov.descuentos.length > 0) {

            descuneto = round((cov.descuentos.sum('porcentaje') / 100) * prima);
        }
        return descuneto;
    }

    const generateCoverages = (rates = null) => {
        //La variable tarificacion contiene los insumos de entrada
        //El resultado de las tarifas son almacenados en poliza.polCobs

        rates = rates ?? poliza.polCobs;
        let sumInsureds = catalogos.coberturas.sumInsureds ?? [];

        var result = catalogos.coberturas.coverages.map((item, i) => {
            let cov = getCoverage(rates, item.idCob);
            let prima = cov != null ? parseFloat(cov.prima) : 0;
            //Aplicar recargo
            if (cov != null && cov.pRecargo > 0)
                prima = prima + (prima * cov.pRecargo) / 100;
            let descuneto = getDescuento(cov);

            prima = prima - descuneto;
            return {
                cobId: item.idCob,
                checked: isChecked(rates, item.idCob),
                name: getName(item.idCob),
                sa: format(cov?.sa),
                prima: format(cov != null ? prima + (prima * cov.pRecargo) / 100 : null),
                sumInsureds: removeDuplicates(sumInsureds.filter(x => x.id == item.idCob).map(s => { return { text: s.text, value: s.value, orden: s.orden } })),
                order: item.orden,
                selectedSA: cov != null ? cov.sa : (sumInsureds.filter(x => x.id == item.idCob)[0]?.value),
                customName: item.idCob == coberturaEquipoEspecial ? coberturaEspecial.customName : null
            };
        });

        return result;
    }

    const getEspecialCoverage = (rates = null) => {
        var coverages = generateCoverages(rates);
        return coverages.find(x => coberturaEquipoEspecial == x.cobId);
    }

    const generateOptionalCoverages = (rates = null) => {
        var coverages = generateCoverages(rates);
        return coverages.filter(x => coberturasOpcionales.some(s => s == x.cobId));
    }

    const removeDuplicates = (sumInsureds) => {
        return sumInsureds.filter((elem, index) => sumInsureds.findIndex(obj => obj.value === elem.value) === index);
    }

    const EspecialCoverageRow = ({ coverage, onCoverageChange, showEspecialCoverage, ...rest }) => {


        const oncCeeClick = (event) => {
            showEspecialCoverage();

        }


        return (
            <td>

                <label> {coverage.name} </label>
                {coverage.cobId == coberturaEquipoEspecial &&
                    <button type="button" style={{ borderRadius: 4, backgroundColor: "#025f46", color: "white", border: "none" }} onClick={oncCeeClick}>
                        {coverage.customName ?? 'Agregar Items'}
                        {coverage.customName == null && <FaPlus />}
                        {coverage.customName != null && <FaPen />}
                    </button>
                }
                {coverage.cobId == coberturaEquipoEspecial &&
                    <FaInfoCircle color="#E1E1E1" data-tip="Son los accesorios o adiciones que no fueron instalados en su vehículo por el fabricante, tiene que adquirir las coberturas “C, F, G”, de lo contrario no podría contratarla." />
                }

            </td>
        );
    }

    const width = window.outerWidth;



    const BoxPrimaMobile = ({header='',value='' }) => {
        return <div className='td-tag-box'>
            <p className='td-tag-title'>{header}</p>
            <p className='td-tag-value'>{value}</p>
        </div>
    }

    const showCoberturaEspecial = () => {
        setCoberturaEspecial({ ...coberturaEspecial, showDialog: true });
    }

    const closeCoberturaEspecial = () => {
        setCoberturaEspecial({ ...coberturaEspecial, showDialog: false });
    }

    const onEquipoEspecialChange = (event) => {
        let name = event.target.name;
        let v = event.target.value;

        setCoberturaEspecial({
            ...coberturaEspecial,
            [name]: v
        });

        let c = getEspecialCoverage();
        if (c != null) {
            c = { ...c };
            if (name == 'sa')
                c.selectedSA = v;
            c[name] = v;
            onCoverageChange(c);
        }
    }

    const limpiarCoberturaEspecial = () => {
        setCoberturaEspecial({ ...coberturaEspecialDefault });
        let c = optCoverages.find(x => x.cobId == coberturaEquipoEspecial);
        if (c != null) {
            onCoverageChange({ ...c, sa: format(0), selectedSA: null, customName: null });
        }
    }


    const closeFailModal = () => setDialogs({ ...dialogs, showFailDialog: false });
    const openFailTeminos = () => setDialogs({ ...dialogs, showFailDialog: true });

    const minWidth = { width: "200x" };

    const getHeader = () => {

        const susCoberturas = <th>Cobertura<FaInfoCircle color="#E1E1E1" data-tip="Protección contratada para cubrir el bien asegurado ante eventuales siniestros." /></th>;

        if (width > 500) {

            return <tr>
                {susCoberturas}
                <th>
                    Suma Asegurada
                    <FaInfoCircle color="#E1E1E1" data-tip="Es el monto máximo de dinero que se contempla para los incidentes cubiertos por cada cobertura." />
                </th>
                <th>Deducible</th>
                <th>Coaseguro</th>
            </tr>;

        }

        return <tr>
            {susCoberturas}
            <th style={{ ...minWidth }}>Suma Asegurada
                <FaInfoCircle color="#E1E1E1" data-tip="Es el monto máximo de dinero que se contempla para los incidentes cubiertos por cada cobertura." data-place="left" />
                /Prima
            </th>
        </tr>;

    }

    const getCoverageRows = (item, i) => {
        let descuneto = getDescuento(item);
        const prima = format(parseFloat(item.prima) + ((parseFloat(item.prima) * item.pRecargo) / 100) - descuneto);
        const especialCov = getEspecialCoverage();
        const deducible=format(item.deducible);
        const coaseguro=formartPercent(item.coa);
        const sa=format(item.sa);
        console.log(item);
        if (width > 500) {
            return <tr key={i}>
                {item.idCob == coberturaEquipoEspecial &&
                    <EspecialCoverageRow coverage={especialCov} showEspecialCoverage={showCoberturaEspecial} />
                }
                {item.idCob != coberturaEquipoEspecial &&
                    <td>{getName(item.idCob)}</td>
                }
                <td className="tnum">{format(item.sa)}</td>
                <td className="tnum">{deducible}</td>
                <td className="tnum">{coaseguro}</td>
                {/* <td className="tnump">{prima}</td> */}
            </tr>;
        }

        return <tr key={i}>
            {item.idCob == coberturaEquipoEspecial &&
                <EspecialCoverageRow coverage={especialCov} showEspecialCoverage={showCoberturaEspecial} />
            }
            {item.idCob != coberturaEquipoEspecial &&
                <td>{getName(item.idCob)}</td>
            }
            <td className="tnump">
                
                <BoxPrimaMobile header='Suma Asegurada' value={sa} />
                <BoxPrimaMobile header='Deducible' value={deducible} />
                <BoxPrimaMobile header='Coaseguro' value={coaseguro} />
            </td>
        </tr>;

    }


    return (
        <div className="reponsive">
            <div style={{ overflowX: 'auto' }}>
                <table className="tcob" width="100%" >
                    <thead className="lfthead">
                        {getHeader()}
                    </thead>
                    <tbody>
                        {
                            poliza.polCobs.map(getCoverageRows)
                        }
                    </tbody>
                </table>
                <div><p className="text-right"><strong>{format(poliza.total)}</strong></p></div>
                <div><p className='text-muted'>*Deducible: 1.00% sobre la Suma Asegurada, mínimo L. 2,000.00 por toda y cada pérdida parcial.</p></div>

                <Modal
                    isOpen={coberturaEspecial.showDialog}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">Equipo Especial</h2>

                    <div className="dialog-center-content">
                        <DivRow width="50%">
                            <Input label="Nombre del Item" field="customName" value={coberturaEspecial.customName} onChange={onEquipoEspecialChange}></Input>
                        </DivRow>
                        <DivRow width="50%">
                            <Input type="number" label="Valor" field="sa" value={coberturaEspecial.sa} onChange={onEquipoEspecialChange}></Input></DivRow>
                    </div>

                    <br />
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={limpiarCoberturaEspecial} style={{ marginRight: "50px" }}>Limpiar</button>
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeCoberturaEspecial}>Aplicar</button>
                    </div>
                </Modal>
                <Modal
                    isOpen={dialogs.showFailDialog}
                    style={customStyles}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal"
                    ariaHideApp={false}
                >
                    <h2 className="txt-primary txt-center">
                        No se ha podido calcular el valor de su prima
                    </h2>
                    <div className="dialog-center-content">
                        <ImgAlert />
                    </div>
                    <h5 className="txt-muted">Verifique si ha ingresado correctamente el valor de los equipos especiales de su vehículo, haga click en el botón ¨Agregar Items¨</h5>
                    <div className="dialog-center-content">
                        <button type="button" className="control-button-btn btn-color-primary" onClick={closeFailModal}>Entendido</button>
                    </div>
                </Modal>
                <Resumen></Resumen>

            </div>
            <ReactTooltip className='tipstyle' multiline={true} />
        </div>
    );
}

export default Step2;